import Tab from "component/react-bootstrap/Tab";
import Tabs from "component/react-bootstrap/Tabs";
import { DepartmentType } from "modules/home/department-constant";
import { useTranslation } from "next-i18next";
import { useEffect, useState } from "react";
import { scrollTo } from "util/scroll-helper";
import { getCategory } from "../../api/category/category.api";
import HomeCategory from "./category/HomeCategory";
import styles from "./home-page.module.scss";

const scrollSettings = {
  duration: 300,
  delay: 0,
  smooth: true,
  offset: -75,
};

function TabsCategory(props: any) {
  const { currentTab, topCategories, component } = props;
  const [activeTab, setActiveTab] = useState(currentTab || (topCategories?.length > 0 ? 1 : 2));
  const { t } = useTranslation("category-map");

  useEffect(() => {
    setActiveTab(currentTab);
  }, [currentTab]);

  function setTabActive(a: any) {
    setActiveTab(a);
    if (props.onChange) {
      props.onChange(a);
    }
  }

  function handleAllReplacementClick(tab: number) {
    setActiveTab(tab);
    scrollTo("anchor-tab-category", scrollSettings);
  }
  return (
    <div data-testid="search-section">
      <div className={`${styles.StyledTabCategoryDiv} ${styles.tabs_category}`}>
        <Tabs
          onSelect={(a: any) => setTabActive(a)}
          activeKey={activeTab}
          component={component}
        >
          {topCategories && topCategories.length > 0 && (
            <Tab eventKey={1} tabClassName="each-tab" title={t("Top Selling")}>
              <HomeCategory
                category={{ sub: topCategories }}
                isTopSelling
                handleAllReplacementClick={handleAllReplacementClick}
              />
            </Tab>
          )}

          <Tab eventKey={2} tabClassName="each-tab" title={t("Replacement Parts")}>
            <HomeCategory
              departmentId={DepartmentType.REPLACEMENT_PARTS.id}
              category={getCategory(DepartmentType.REPLACEMENT_PARTS.id)}
            />
          </Tab>

          <Tab eventKey={3} tabClassName="each-tab" title={t("Lighting")}>
            <HomeCategory
              departmentId={DepartmentType.AUTOMOTIVE_LIGHTINGS.id}
              category={getCategory(DepartmentType.AUTOMOTIVE_LIGHTINGS.id)}
            />
          </Tab>

          <Tab eventKey={4} tabClassName="each-tab" title={t("Body Parts")}>
            <HomeCategory
              departmentId={DepartmentType.BODY_PARTS.id}
              category={getCategory(DepartmentType.BODY_PARTS.id)}
            />
          </Tab>

          <Tab eventKey={5} tabClassName="each-tab" title={t("Tires & Wheels")}>
            <HomeCategory
              departmentId={DepartmentType.WHEELS_AND_TIRES.id}
              category={getCategory(DepartmentType.WHEELS_AND_TIRES.id)}
            />
          </Tab>

          <Tab eventKey={6} tabClassName="each-tab" title={t("Tools")}>
            <HomeCategory
              departmentId={DepartmentType.TOOLS_EQUIPMENT.id}
              category={getCategory(DepartmentType.TOOLS_EQUIPMENT.id)}
            />
          </Tab>

          <Tab eventKey={7} tabClassName="each-tab" title={t("Performance")}>
            <HomeCategory
              departmentId={DepartmentType.PERFORMANCE_PARTS.id}
              category={getCategory(DepartmentType.PERFORMANCE_PARTS.id)}
            />
          </Tab>

          <Tab eventKey={8} tabClassName="each-tab" title={t("Interior")}>
            <HomeCategory
              departmentId={DepartmentType.INTERIOR.id}
              category={getCategory(DepartmentType.INTERIOR.id)}
            />
          </Tab>

          <Tab eventKey={9} tabClassName="each-tab" title={t("Exterior")}>
            <HomeCategory
              departmentId={DepartmentType.EXTERIOR.id}
              category={getCategory(DepartmentType.EXTERIOR.id)}
            />
          </Tab>

          <Tab eventKey={10} tabClassName="each-tab" title={t("Specialty Parts")}>
            <HomeCategory
              departmentId={DepartmentType.SPECIALTY_PARTS.id}
              category={getCategory(DepartmentType.SPECIALTY_PARTS.id)}
            />
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}

export default TabsCategory;
